<template>
  <qx-card title="事故记录" class="detail">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='vehicleServiceBO.ajax?cmd=doQueryAccidentList'
          :params="fullSearchData"
          bizName="车辆事故记录导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
        >
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <!-- <section slot-scope="scope"></section> -->
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total || 0"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import ExportBtn from 'components/exportBtn';
import tableMixin from '@qx/mixin/table';
import {
  accidentList,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      downloadParams: {
        vehicleCode: this.$route.query.id,
        _ALLEXPORT: 1,
        excelLables: '事故时间,是否结案,结案时间,事故地点,核赔金额,核赔日期,核赔账户,我方损失金额,对方损失金额,维修金额,是否本车车损,是否对方车损,是否物损,是否损坏道路,是否伤人,主驾司机,主驾电话,副驾司机,副驾电话,事故司机,事故类型,事故原因,责任划分',
        /* eslint-disable */
        excelKeys: 'accidentTime,isClosingCaseName,closingCaseDate,accidentAddress,settAmt,compensationDate,settAccount,lossAmt,otherLossAmt,repairServiceAmt,isVehicleDamageName,isOtherAccidentName,isGoodsDamageName,isRoadDamageName,isWoundingName,mainUserName,mainUserTel,viceUserName,viceUserTel,accidentDriver,accidentType,accidentRemark,responsibilityAttribution',
      },
      searchBoxData: {
        vehicleCode: this.$route.query.id,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {
            prop: 'accidentTime',
            label: '事故时间',
          },
          {
            prop: 'isClosingCaseName',
            label: '是否结案',
          },
          {
            prop: 'closingCaseDate',
            label: '结案时间',
          },
          {
            prop: 'accidentAddress',
            label: '事故地点',
          },
          {
            prop: 'settAmt',
            label: '核赔金额',
          },
          {
            prop: 'compensationDate',
            label: '核赔日期',
          },
          {
            prop: 'settAccount',
            label: '核赔账户',
          },
          {
            prop: 'lossAmt',
            label: '我方损失金额',
          },
          {
            prop: 'otherLossAmt',
            label: '对方损失金额',
          },
          {
            prop: 'repairServiceAmt',
            label: '维修金额',
          },
          {
            prop: 'isVehicleDamageName',
            label: '是否本车车损',
          },
          {
            prop: 'isOtherAccidentName',
            label: '是否对方车损',
          },
          {
            prop: 'isGoodsDamageName',
            label: '是否物损',
          },
          {
            prop: 'isRoadDamageName',
            label: '是否损坏道路',
          },
          {
            prop: 'isWoundingName',
            label: '是否伤人',
          },
          {
            prop: 'mainUserName',
            label: '主驾司机',
          },
          {
            prop: 'mainUserTel',
            label: '主驾电话',
          },
          {
            prop: 'viceUserName',
            label: '副驾司机',
          },
          {
            prop: 'viceUserTel',
            label: '副驾电话',
          },
          {
            prop: 'accidentDriver',
            label: '事故司机',
          },
          {
            prop: 'accidentType',
            label: '事故类型',
          },
          {
            prop: 'accidentRemark',
            label: '事故原因',
          },
          {
            prop: 'accidentResponsibility',
            label: '责任划分',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: accidentList,
  },
};
</script>

<style>
</style>
